export const DESTINATION_KEYS = ['hotelId', 'placeId'] as const
export const ITINERARY_KEYS = ['checkIn', 'checkOut', 'rooms'] as const
